// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IEnrollmentReportErrorDetailsDto } from './IEnrollmentReportErrorDetailsDto';
import {
    IEnrollmentReportErrorDetailsDtoFromJSON,
    IEnrollmentReportErrorDetailsDtoFromJSONTyped,
    IEnrollmentReportErrorDetailsDtoToJSON,
    IEnrollmentReportErrorDetailsDtoToJSONTyped,
} from './IEnrollmentReportErrorDetailsDto';

/**
 * 
 * @export
 * @interface IEnrollmentReportDto
 */
export interface IEnrollmentReportDto {
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentReportDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentReportDto
     */
    status?: IEnrollmentReportDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentReportDto
     */
    message?: string;
    /**
     * 
     * @type {Array<IEnrollmentReportErrorDetailsDto>}
     * @memberof IEnrollmentReportDto
     */
    error_details?: Array<IEnrollmentReportErrorDetailsDto>;
}

/**
* @export
* @enum {string}
*/
export enum IEnrollmentReportDtoStatusEnum {
    SUCCEED = 'SUCCEED',
    FAILURE = 'FAILURE'
}


/**
 * Check if a given object implements the IEnrollmentReportDto interface.
 */
export function instanceOfIEnrollmentReportDto(value: object): value is IEnrollmentReportDto {
    return true;
}

export function IEnrollmentReportDtoFromJSON(json: any): IEnrollmentReportDto {
    return IEnrollmentReportDtoFromJSONTyped(json, false);
}

export function IEnrollmentReportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEnrollmentReportDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'status': json['status'] == null ? undefined : json['status'],
        'message': json['message'] == null ? undefined : json['message'],
        'error_details': json['errorDetails'] == null ? undefined : ((json['errorDetails'] as Array<any>).map(IEnrollmentReportErrorDetailsDtoFromJSON)),
    };
}

export function IEnrollmentReportDtoToJSON(json: any): IEnrollmentReportDto {
    return IEnrollmentReportDtoToJSONTyped(json, false);
}

export function IEnrollmentReportDtoToJSONTyped(value?: IEnrollmentReportDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
        'message': value['message'],
        'errorDetails': value['error_details'] == null ? undefined : ((value['error_details'] as Array<any>).map(IEnrollmentReportErrorDetailsDtoToJSON)),
    };
}

